import api from '@api';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getOrdersGridFetchSuccess, getOrdersGridFetchFailure } from './reducer';
import { OrdersGridResType } from 'src/types/ordersGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';

export const ORDER_GRID_URL = 'api/secure/orders/grid';
export const ORDER_GRID_ALL_PROVIDERS_URL = 'api/secure/orders/grid-all-providers';
export const ORDER_GRID_PRODUCTS_URL = 'api/secure/orders/ordersProducts';
export const ORDER_GRID_PRODUCTS_SUMMARIZED_URL = 'api/secure/orders/ordersProductsSummarized';

export interface GetOrderGridCallPayloadType {
    params: GridRequestType;
    allProviders: boolean;
}

const getOrdersGridFetchRequest = async (payload: GetOrderGridCallPayloadType) => {
    const res = await api('post', payload.allProviders ? ORDER_GRID_ALL_PROVIDERS_URL : ORDER_GRID_URL, payload.params);
    return res.data.data;
};

function* getOrdersGridFetch(action: { type: string; payload?: GetOrderGridCallPayloadType }) {
    try {
        let payloadData: GetOrderGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select((state: RootStoreType) => state.ordersGrid.data?.request);
            const allProviders: boolean = yield select((state: RootStoreType) => state.ordersGrid.allProviders);
            if (params) {
                payloadData = {
                    params,
                    allProviders,
                };
            }
        }

        if (payloadData) {
            // @ts-ignore
            const response: OrdersGridResType = yield call((): any => getOrdersGridFetchRequest(payloadData));
            yield put(getOrdersGridFetchSuccess(response));
        } else {
            yield put(getOrdersGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getOrdersGridFetchFailure({ error }));
    }
}

export function* getOrdersGridFetchWatch() {
    yield takeEvery('ordersGrid/getOrdersGridFetch', getOrdersGridFetch);
}
